import { ProductableType } from 'interfaces/products';
import { getTenant } from 'services/tenants';

interface ProductableTypesProps {
  label: string;
  value: ProductableType;
}

const tenant = getTenant();
const externalItemsEnabled =
  !tenant.disabledFeatures?.includes('external_items');

const allProductTypes: ProductableTypesProps[] = [
  {
    label: 'Curso livre',
    value: 'Course'
  },
  {
    label: 'Curso regulado',
    value: 'Graduate::Course'
  },
  {
    label: 'Set',
    value: 'Products::Set'
  },
  {
    label: 'Combo',
    value: 'Products::Bundle'
  },
  {
    label: 'Item externo',
    value: 'ExternalItem'
  }
];

// Filter out ExternalItem if disabled for this tenant
export const PRODUCTABLE_TYPES: ProductableTypesProps[] = externalItemsEnabled
  ? allProductTypes
  : allProductTypes.filter(type => type.value !== 'ExternalItem');
